import type { LinkComponent, ThemeFooterProps } from "@op/puck-types";
import { LinkButton, Ow_Footer } from "@op/sf-op";
import { useTranslation } from "@op/utils";
import { DefaultLinkComponent } from "./ThemeNav";

interface FooterLinkProps {
  label: string;
  legalPage: "imprint" | "privacy";
  internal?: boolean;
  external?: string;
  languageKey: string;
  LinkComponent: LinkComponent;
}

const FooterLink = ({
  label,
  legalPage,
  internal,
  external,
  languageKey,
  LinkComponent,
}: FooterLinkProps) => {
  if (internal) {
    return (
      <LinkComponent
        to="/$languageKey/legal/$legalPage"
        params={{ languageKey, legalPage }}
        className="contents"
      >
        <LinkButton variant="inverse" size="small">
          {label}
        </LinkButton>
      </LinkComponent>
    );
  }
  if (!external) return null;
  return (
    <a href={external} target="_blank">
      <LinkButton variant="inverse" size="small">
        {label}
      </LinkButton>
    </a>
  );
};

export const ThemeFooter = ({
  copyrightText,
  imprintLink,
  privacyLink,
  hasImprint,
  hasPrivacyPolicy,
  languageKey,
  LinkComponent = DefaultLinkComponent,
}: ThemeFooterProps) => {
  const { legal } = useTranslation();
  const visible =
    copyrightText ||
    hasImprint ||
    imprintLink ||
    hasPrivacyPolicy ||
    privacyLink;
  if (!visible) return null;

  return (
    <Ow_Footer
      copyrightText={
        copyrightText ? `© ${new Date().getFullYear()} ${copyrightText}` : ""
      }
      links={
        <>
          <FooterLink
            label={legal.imprint}
            legalPage="imprint"
            internal={hasImprint}
            external={imprintLink}
            languageKey={languageKey}
            LinkComponent={LinkComponent}
          />
          <FooterLink
            label={legal.privacy}
            legalPage="privacy"
            internal={hasPrivacyPolicy}
            external={privacyLink}
            languageKey={languageKey}
            LinkComponent={LinkComponent}
          />
        </>
      }
    />
  );
};

export default ThemeFooter;
